module.exports = __webpack_public_path__ + "img/icon3.170cb714.svg";